import {getApiUrl} from "./client";
import {HOTSPOT_HABITAT_FEEDBACK_ENDPOINT} from "./constants";

export type HotspotHabitatFeedbackSubmission = {
    feedbackType: 'confirm' | 'correct';
    locationId: string;
    hotspotName: string;
    latitude: number;
    longitude: number;
    classifierVersion: string;
    predictedHabitat: string;
    predictedDisplayHabitat?: string;
    predictedBaseHabitat?: string;
    predictedFamily: string;
    predictedDisplayFamily?: string;
    predictedBaseFamily?: string;
    predictedConfidence: string;
    suggestedHabitat?: string;
    suggestedRuleLabel?: string;
    notes?: string;
    pageRoute: string;
    pageUrl: string;
    predictionContext: Record<string, unknown>;
    hotspotContext: Record<string, unknown>;
};

export type HotspotHabitatFeedbackSubmitResponse = {
    status: string;
    feedback: {
        id: number;
        feedbackType: 'confirm' | 'correct';
        locationId: string;
        status: string;
        createdAt: string;
    };
};

export const submitHotspotHabitatFeedback = async (submission: HotspotHabitatFeedbackSubmission) => {
    const response = await fetch(getApiUrl(HOTSPOT_HABITAT_FEEDBACK_ENDPOINT), {
        method: 'POST',
        credentials: 'include',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(submission)
    });

    if (!response.ok) {
        let message = `Habitat feedback submission failed with ${response.status}`;

        try {
            const payload = await response.json();
            if (payload?.message) {
                message = payload.message;
            }
        } catch (error) {
            // Ignore parse errors and surface the HTTP status instead.
        }

        throw new Error(message);
    }

    return await response.json() as HotspotHabitatFeedbackSubmitResponse;
};
